window.msbCollect = function(result) {
    //console.log("msbCollect called with:", result);

    // 1) keep ONLY failures
    if (result.success === true) {
        //console.log("Stored MSB errors (SKIP push):", window.msbLocalValidationResults);
        return; // do not store successes
    }

    // 2) ensure array exists
    if (!window.msbLocalValidationResults) {
        window.msbLocalValidationResults = [];
    }

    // 3) avoid duplicate identical error messages in the same cycle
    const alreadyExists = window.msbLocalValidationResults.some(
        r => r.message === result.message
    );
    if (alreadyExists) {
        //console.log("Duplicate MSB error skipped:", result.message);
        return;
    }

    window.msbLocalValidationResults.push(result);

    //console.log("Stored MSB errors:", window.msbLocalValidationResults);
};
	
	
		
export function reset_dauer(dauer) {
// sets the hidden form element for a 'dauer' to null and writes some empty text into the inner of a 'span'
	if (dauer) {
		$(dauer).val('');
		$('#value_' + dauer.substring(1)).html('--');
	}
}


export function reset_values(the_field) {
    if (the_field) {
        if ($(the_field))
            $(the_field).val('');

        switch (the_field) {
            case '#record_fahrt_von':
            case '#record_fahrt_bis':
                reset_dauer('#record_fahrt_dauer_ist');
                check_pause_between('#record_fahrt_bis', '#record_von', '#pause_fahrt', the_field);
                break;
            case '#record_von':
            case '#record_bis':
                reset_dauer('#record_dauer');
                reset_dauer('#record_ub_vorort_dauer_ist');
                check_pause_between('#record_fahrt_bis', '#record_von', '#pause_fahrt', the_field);
                break;
            case '#record_ub_fahrt_von':
            case '#record_ub_fahrt_bis':
                reset_dauer('#record_ub_fahrt_dauer');
                reset_dauer('#record_ub_vorort_dauer_ist');
                break;
        }
    }

}

export function reset_all_values() {
    reset_values("#record_von");
    reset_values("#record_bis");
    reset_values("#record_fahrt_von");
    reset_values("#record_fahrt_bis");
    reset_values("#record_ub_fahrt_von");
    reset_values("#record_ub_fahrt_bis");
    reset_values("#record_fahrt_startadresse");
    reset_values("#record_fahrt_zieladresse");
    reset_values("#record_fahrt_km_ist");
    reset_values("#record_ub_fahrt_startadresse");
    reset_values("#record_ub_fahrt_zieladresse");
    reset_values("#record_ub_fahrt_km");
}


export function reset_hidden_values() {
    if (!is_visible('#msb_time_form_fahrt')) {
        reset_values("#record_fahrt_von");
        reset_values("#record_fahrt_bis");
        reset_values("#record_fahrt_startadresse");
        reset_values("#record_fahrt_zieladresse");
        reset_values("#record_fahrt_km_ist");
    }

    if (!is_visible('#msb_time_form_kb')) {
        reset_values("#record_von");
        reset_values("#record_bis");
        reset_values("#record_ub_fahrt_von");
        reset_values("#record_ub_fahrt_bis");
        reset_values("#record_ub_fahrt_startadresse");
        reset_values("#record_ub_fahrt_zieladresse");
        reset_values("#record_ub_fahrt_km");
        $('#record_von').val($('#record_fahrt_von').val());
        $('#record_bis').val($('#record_fahrt_von').val());
        $('#record_dauer').val(0);
    }


}


export function calculate_dauer________V1_________(time_from, time_to, dauer, the_focus) {
// this function assumes a correct time-format!
// 1. Sets the hidden variable 'dauer' to the amount of minutes as the difference time_to-time_from
// 2. prints the Text as innerHTML in the DOM-element with the id 'value_'+dauer

        var d = moment_get_duration(time_from, time_to)

        if ($(time_from).val() && $(time_to).val() && d>0) {
            d = d/1000/60;
            $(dauer).val(d/60); //  d/60 for hours!!
            //console.log('calculate_dauer',dauer,d);
            $('#value_' + dauer.substring(1)).text(d + 'min');
        } else {
            //reset_dauer(dauer);
            //alert_von_bis(time_from, time_to, 'von', 'bis', the_focus);
        }

}



export function calculate_vorort_dauer() {
// Dauer Vor ort ist Gesamt Dauer - UB im Rahmen einer Fahrt
    var dauer=$('#record_dauer').val();
    var ub_fahrt_dauer=$('#record_ub_fahrt_dauer').val();
    if (dauer) {
		if (ub_fahrt_dauer=="") {
            ub_fahrt_dauer = 0;
		}
        var vor_ort_dauer=Number(dauer) - Number(ub_fahrt_dauer);
        //console.log('calculate_vorort_dauer','ub_fahrt_dauer',ub_fahrt_dauer, 'dauer',dauer, 'vor_ort_dauer',vor_ort_dauer)
		$('#record_ub_vorort_dauer_ist').val(vor_ort_dauer);
		$('#value_record_ub_vorort_dauer_ist').html(Math.round(vor_ort_dauer*60)+'min');
	}
}



export function check_pause_between(time_to, time_from, pause_type, the_focus) {
    const pauseRes = moment_datetime_range_validation(time_to, time_from, 'Betreuungsbeginn muss NACH Anfahrtsende liegen. ', '#submit_button', true);

    const t = moment_time(time_to);
    const f = moment_time(time_from);
    const d = moment_get_duration(time_to, time_from) / 1000 / 60;

    if (!pauseRes.success) {

    } else if (t.isValid() && f.isValid() && d !== 0) {
        $('#region_' + pause_type.substring(1)).removeClass('hidden').addClass('visible');
        $('#value_' + pause_type.substring(1)).html(d + 'min');

    } else {
        $('#region_' + pause_type.substring(1)).removeClass('visible').addClass('hidden');
        $('#value_' + pause_type.substring(1)).html('');
    }

    msbCollect(pauseRes);
    return pauseRes;
}




export function check_betreuungszeiten(the_focus) {
    let success = true;
    let message = '';

    const von          = moment_datetime('#record_von');
    const bis          = moment_datetime('#record_bis');
    const ub_fahrt_von = moment_datetime('#record_ub_fahrt_von');
    const ub_fahrt_bis = moment_datetime('#record_ub_fahrt_bis');

    if (von.isValid() && bis.isValid() && ub_fahrt_von.isValid() && ub_fahrt_bis.isValid()) {

        const validRange =
            von.isSameOrBefore(ub_fahrt_von, 'minute') &&
            ub_fahrt_von.isBefore(ub_fahrt_bis, 'minute') &&
            ub_fahrt_bis.isSameOrBefore(bis, 'minute');

        if (!validRange) {
            success = false;
            message = "Betreuungszeiten dürfen sich nicht überlappen\n";
        }
    }

    const result = {success, message};
    msbCollect(result);
    return result;
}



export function check_for_open_time_windows(von, bis) {
// returns 1 if neither both nor none of the 'von' - 'bis' values are present (XOR)
	if ( !((!$(von).val() && !$(bis).val()) || ($(von).val() && $(bis).val())) )
		return 1
	else
		return 0
}


export function check_for_completeness() {
    // checks if all time-pairs which are used, are complete

    // 260721nrai: r4 merge — ganztägig: keine offenen Zeitfenster prüfen
    if (typeof record_is_all_day === 'function' && record_is_all_day()) {
        return 0;
    }

    var count_open_time_windows = 0;

    if (is_visible('#msb_time_form_fahrt'))
        count_open_time_windows += check_for_open_time_windows('#record_fahrt_von', '#record_fahrt_bis');

    if (is_visible('#msb_time_form_kb')) {
        if ( (!$('#record_von').val() || !$('#record_bis').val()) && (!$('#fahrt_von_time').val() && !$('#fahrt_bis_time').val() )  ) {
            count_open_time_windows += 1
        }
        count_open_time_windows += check_for_open_time_windows('#record_von', '#record_bis');
        count_open_time_windows += check_for_open_time_windows('#record_ub_fahrt_von', '#record_ub_fahrt_bis');
    }

    return count_open_time_windows;
}





export function prepare_msb_form_values() {
    // in edit mode:
    // 1. reformats the time-fields from hh:mm:ss to hh:mm
    // 2. calculates dauer

    $('#msb_time_form_fahrt').hide();
    var f='YYYY-MM-DD HH:mm:ss Z';
    var von=moment($('#record_von').val(), f);
    var bis=moment($('#record_bis').val(), f);
    var fahrt_von=moment($('#record_fahrt_von').val(), f);
    var fahrt_bis=moment($('#record_fahrt_bis').val(), f);
    var ub_fahrt_von=moment($('#record_ub_fahrt_von').val(), f);
    var ub_fahrt_bis=moment($('#record_ub_fahrt_bis').val(), f);

    if ($('#record_fahrt_von').val()) {
        //Anfahrt
        $('#msb_time_form_fahrt').show('fast');
        $('#fahrt_von_time').val(fahrt_von.format('HH:mm'));
        $('#fahrt_bis_time').val(fahrt_bis.format('HH:mm'));
        compose_datetime('#record_fahrt_von', '#von_date', '#fahrt_von_time');
        time_changed('#record_fahrt_von');
        compose_datetime('#record_fahrt_bis', '#von_date', '#fahrt_bis_time');
        time_changed('#record_fahrt_bis');

    }
    if ($('#record_ub_fahrt_von').val()) {
        $('#ub_fahrt_von').val(ub_fahrt_von.format('HH:mm'));
        $('#ub_fahrt_bis').val(ub_fahrt_bis.format('HH:mm'));
        compose_datetime('#record_ub_fahrt_von', '#von_date', '#ub_fahrt_von');
        time_changed('#record_ub_fahrt_von');
        compose_datetime('#record_ub_fahrt_bis', '#von_date', '#ub_fahrt_bis');
        time_changed('#record_ub_fahrt_bis');
    }
    compose_datetime('#record_von', '#von_date', '#von_time');
    time_changed('#record_von');
    compose_datetime('#record_bis', '#von_date', '#bis_time');
    time_changed('#record_bis');

    if ($('#record_fahrt_von').val()==$('#record_von').val() && $('#record_fahrt_von').val()==$('#record_bis').val()) {
        //reset_values("#record_von");
        //reset_values("#record_bis");
    }

    format_comma('#record_fahrt_km_ist', 'fromdb');
    format_comma('#record_ub_fahrt_km', 'fromdb');
	
}



export async function time_changed(the_field) {
    let success = true;
    let message = '';
    let rangeRes = '';

    // reset for next cycle
    window.msbLocalValidationResults = [];

    // 260721nrai: r4 merge — Ganztag short-circuit for von/bis
    var allDay = (typeof record_is_all_day === 'function') && record_is_all_day();

    // Ganztag: von/bis nur aus Datumsfeldern — keine Zeitfenster-/Formatprüfung auf record_von/bis
    if (allDay && (the_field === '#record_von' || the_field === '#record_bis')) {
        if (typeof validateDateTimeFields === 'function') {
            var valid = validateDateTimeFields();
            $('#form_eval_error_for_datetime_fields').val(valid ? 'false' : 'true');
        }
        calculate_dauer('#record_von', '#record_bis', '#record_dauer', '#bis_time', true);
        reset_hidden_values();
        return { success: true, message: '' };
    }

    // Basic syntax/format check
    if (!moment_datetime_validation(the_field, 'Falsche Zeitangabe', '#submit_button')) {
        if ($(the_field).val()) {
            message = "Falsches Zeitformat! Bitte im Format 'hh:mm' eingeben.";
            success = false;
            reset_values(the_field);
            $(the_field).focus();
        } else {
            reset_values(the_field);
        }
        msbCollect({success, message});
        return {success, message};
    }

    //
    // NORMAL SUCCESSFUL TIME PARSE
    //
    switch (the_field) {

        // ---------------- Betreuung von ----------------
        case '#record_von':
            validateDateTimeFields();
            compose_datetime('#record_von', '#von_date', '#von_time', {'all_day': allDay});
            rangeRes = moment_datetime_range_validation('#record_von', '#record_bis', 'Bis muss NACH Von liegen. ', '#submit_button', true);
            if (!rangeRes.success) {
                msbCollect(rangeRes);
                return;
            }
            calculate_dauer('#record_von', '#record_bis', '#record_dauer', '#bis_time', allDay);
            check_betreuungszeiten(the_field);
            calculate_vorort_dauer();
            if (is_visible('#msb_time_form_fahrt')) {
                check_pause_between('#record_fahrt_bis', '#record_von', '#pause_fahrt', the_field);
            }
            //set_workdays('#von_date', '#bis_date');

            // propagate updates
            if ($('#record_fahrt_von').val()) time_changed('#record_fahrt_von');
            if ($('#record_fahrt_bis').val()) time_changed('#record_fahrt_bis');
            if ($('#record_ub_fahrt_von').val()) time_changed('#record_ub_fahrt_von');
            if ($('#record_ub_fahrt_bis').val()) time_changed('#record_ub_fahrt_bis');
            break;

        // ---------------- Betreuung bis ----------------
        case '#record_bis':
            validateDateTimeFields();
            compose_datetime('#record_bis', '#bis_date', '#bis_time', {'all_day': allDay, 'day_offset': 1});
            rangeRes = moment_datetime_range_validation('#record_von', '#record_bis', 'Bis muss NACH Von liegen. ', '#submit_button', true);
            if (!rangeRes.success) {
                msbCollect(rangeRes);
                return;
            }
            calculate_dauer('#record_von', '#record_bis', '#record_dauer', '#bis_time', allDay);
            calculate_vorort_dauer();
            check_betreuungszeiten(the_field);
            if (is_visible('#msb_time_form_fahrt')) {
                check_pause_between('#record_fahrt_bis', '#record_von', '#pause_fahrt', the_field);
            }
            //set_workdays('#von_date', '#bis_date');
            break;

        // ---------------- Fahrt ----------------
        case '#record_fahrt_von':
            compose_datetime('#record_fahrt_von', '#von_date', '#fahrt_von_time');
            rangeRes = moment_datetime_range_validation('#record_fahrt_von', '#record_fahrt_bis', 'Fahrt Bis muss NACH Fahrt Von liegen. ', '#submit_button', true);
            if (!rangeRes.success) {
                msbCollect(rangeRes);
                return;
            }
            calculate_dauer('#record_fahrt_von', '#record_fahrt_bis', '#record_fahrt_dauer_ist', '#fahrt_bis_time');
            break;

        case '#record_fahrt_bis':
            compose_datetime('#record_fahrt_bis', '#von_date', '#fahrt_bis_time');
            rangeRes = moment_datetime_range_validation('#record_fahrt_von', '#record_fahrt_bis', 'Fahrt Bis muss NACH Fahrt Von liegen. ', '#submit_button', true);
            if (!rangeRes.success) {
                msbCollect(rangeRes);
                return;
            }
            calculate_dauer('#record_fahrt_von', '#record_fahrt_bis', '#record_fahrt_dauer_ist', '#fahrt_bis_time');
            if (is_visible('#msb_time_form_kb')) {
                check_pause_between('#record_fahrt_bis', '#record_von', '#pause_fahrt', the_field);
            }
            break;


        // ---------------- UB-Fahrt ----------------
        case '#record_ub_fahrt_von':
            compose_datetime('#record_ub_fahrt_von', '#von_date', '#ub_fahrt_von');
            rangeRes = moment_datetime_range_validation('#record_ub_fahrt_von', '#record_ub_fahrt_bis', 'UB i.r.e.Fahrt Bis muss NACH UB i.r.e.Fahrt Von liegen. ', '#submit_button', true);
            if (!rangeRes.success) {
                msbCollect(rangeRes);
                return;
            }
            calculate_dauer('#record_ub_fahrt_von', '#record_ub_fahrt_bis', '#record_ub_fahrt_dauer', '#ub_fahrt_bis');
            calculate_vorort_dauer();
            check_betreuungszeiten(the_field);
            break;

        case '#record_ub_fahrt_bis':
            compose_datetime('#record_ub_fahrt_bis', '#von_date', '#ub_fahrt_bis');
            rangeRes = moment_datetime_range_validation('#record_ub_fahrt_von', '#record_ub_fahrt_bis', 'UB i.r.e.Fahrt Bis muss NACH UB i.r.e.Fahrt Von liegen. ', '#submit_button', true);
            if (!rangeRes.success) {
                msbCollect(rangeRes);
                return;
            }
            calculate_dauer('#record_ub_fahrt_von', '#record_ub_fahrt_bis', '#record_ub_fahrt_dauer', '#ub_fahrt_bis');
            calculate_vorort_dauer();
            check_betreuungszeiten(the_field);
            break;
    }

    reset_hidden_values();

}


window.validateMSBExtendedFields_____DEBUG_VERSION____ = function() {
    let success = true;
    let error_msg = '';

    console.group("MSB Extended Validation");

    // Gather all raw values upfront (no logic changes)
    const allDay                    = is_true($('#record_all_day').val());
    const fahrtFormVisible          = is_visible('#msb_time_form_fahrt');
    const kbFormVisible             = is_visible('#msb_time_form_kb');

    const fahrtVon                 = $('#record_fahrt_von').val();
    const fahrtBis                 = $('#record_fahrt_bis').val();
    const fahrtStart               = $('#record_fahrt_startadresse').val();
    const fahrtZiel                = $('#record_fahrt_zieladresse').val();
    const fahrtKm                  = $('#record_fahrt_km_ist').val();

    const ubVon                    = $('#record_ub_fahrt_von').val();
    const ubBis                    = $('#record_ub_fahrt_bis').val();
    const ubStart                  = $('#record_ub_fahrt_startadresse').val();
    const ubZiel                   = $('#record_ub_fahrt_zieladresse').val();
    const ubKm                     = $('#record_ub_fahrt_km').val();

    console.log("allDay:", allDay);
    console.log("fahrtFormVisible:", fahrtFormVisible);
    console.log("kbFormVisible:", kbFormVisible);

    console.log("Fahrt Values:", {
        fahrtVon,
        fahrtBis,
        fahrtStart,
        fahrtZiel,
        fahrtKm
    });

    console.log("UB Values:", {
        ubVon,
        ubBis,
        ubStart,
        ubZiel,
        ubKm
    });

    // ===============================
    //      Validation Logic
    // ===============================

    if (allDay != 1) {

        // Format numbers
        format_comma('#record_fahrt_km_ist', 'todb');
        format_comma('#record_ub_fahrt_km',  'todb');

        // completeness check
        const open_time_windows = check_for_completeness();
        console.log("open_time_windows:", open_time_windows);

        if (open_time_windows > 0) {
            error_msg += "Offene Zeitfenster wurden gefunden. von-bis Zeiten müssen vollständig angegeben werden!<br/>";
            success = false;
        }

        // Fahrt block validation
        if (fahrtFormVisible && fahrtBis &&
            (!fahrtStart || !fahrtZiel || !fahrtKm)) {

            console.warn("Fahrt validation FAILED because one of the required fields is missing.");

            error_msg += 'Bitte geben Sie die >>Fahrt<< Start- und Zieladressen, sowie km an.<br/>';
            success = false;
        }

        // UB Fahrt block validation
        if (kbFormVisible && ubBis &&
            (!ubStart || !ubZiel || !ubKm)) {

            console.warn("UB i.r.e. Fahrt validation FAILED because one of the required fields is missing.");

            error_msg += 'Bitte geben Sie die Start- und Zieladressen, sowie km der >>UB i.r.e Fahrt<< an.<br/>';
            success = false;
        }
    }

    // Final state tracing
    console.log("Final success:", success);
    console.log("Final error_msg:", error_msg);

    console.groupEnd();

    $('#form_eval_error_for_msb').val(success ? 'false' : 'true');

    return { success: success, message: error_msg };
};


function check_betreuungszeiten_____DEBUG_VERSION____(the_focus) {
    let success = true;
    let message = '';

    console.group("check_betreuungszeiten");

    const von          = moment_datetime('#record_von');
    const bis          = moment_datetime('#record_bis');
    const ub_fahrt_von = moment_datetime('#record_ub_fahrt_von');
    const ub_fahrt_bis = moment_datetime('#record_ub_fahrt_bis');

    // --- Dump raw values ---
    console.log("Input values:", {
        focus: the_focus,
        von: von ? von.format() : "[invalid]",
        bis: bis ? bis.format() : "[invalid]",
        ub_fahrt_von: ub_fahrt_von ? ub_fahrt_von.format() : "[invalid]",
        ub_fahrt_bis: ub_fahrt_bis ? ub_fahrt_bis.format() : "[invalid]"
    });

    if (von.isValid() && bis.isValid() && ub_fahrt_von.isValid() && ub_fahrt_bis.isValid()) {

        // --- Evaluate all range checks ---
        const cond1 = von.isSameOrBefore(ub_fahrt_von, "minute");
        const cond2 = ub_fahrt_von.isBefore(ub_fahrt_bis, "minute");
        const cond3 = ub_fahrt_bis.isSameOrBefore(bis, "minute");

        // --- Log condition results ---
        console.log("Range conditions:", {
            "von <= ub_fahrt_von": cond1,
            "ub_fahrt_von < ub_fahrt_bis": cond2,
            "ub_fahrt_bis <= bis": cond3
        });

        const validRange = cond1 && cond2 && cond3;

        console.log("validRange:", validRange);

        if (!validRange) {
            success = false;
            message = "Betreuungszeiten dürfen sich nicht überlappen\n";
            console.warn("❌ Betreuungszeiten overlap detected!");
        } else {
            console.log("✔ Betreuungszeiten are valid (no overlap).");
        }

    } else {
        console.warn("Some datetime fields were invalid, skipping overlap validation.");
    }

    const result = { success, message };

    console.log("Result:", result);
    console.groupEnd();

    msbCollect(result);
    return result;
}
